
import React, { useMemo, useState } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { usePharmaDeliveriesUIContext } from "../PharmaDeliveriesUIContext";
import { shallowEqual, useSelector } from "react-redux";
import Select from 'react-select'

const prepareFilter = (queryParams, values) => {
    const { searchText, searchIdText, searchInvoice, business_unit_id } = values;
    
    const newQueryParams = { ...queryParams, filter:{...queryParams.filter} };

    newQueryParams.filter.shipping_type = "3";//Retiro en Farmacia

    // Filter by business_unit_id
    if (business_unit_id) {
      newQueryParams.filter.business_unit_id = business_unit_id;
      if  (business_unit_id==1){ //shopdrofar
        newQueryParams.filter.logistic_state_id = "3,4,6"
        newQueryParams.filter.pharmacy_take_off = 1
      }
      else if (business_unit_id==2){ //ethical nutrition
        newQueryParams.filter.logistic_state_id = "3,4,6"
        newQueryParams.filter.pharmacy_take_off = 0
      }
      else if (business_unit_id==3){ //mitest
        newQueryParams.filter.logistic_state_id = "3,4,6"
        newQueryParams.filter.pharmacy_take_off = 1
      }
    }
    else{
      newQueryParams.filter.business_unit_id = undefined;
    }
    // Filter by order_id
    if (searchIdText) {
      newQueryParams.filter.id = searchIdText;
    }
    else{
      newQueryParams.filter.id = undefined;
    }
    
    // Filter by invoice
    if (searchInvoice) {
      newQueryParams.filter.invoice = searchInvoice;
    }
    else{
      newQueryParams.filter.invoice = undefined;
    }

    // Filter by all fields
    if (searchText) {
      newQueryParams.filter.client_name = searchText;
      //filter.client_tax_number = searchText;
    }
    else{
      newQueryParams.filter.client_name = undefined;
    }

    return newQueryParams;
};

export function PharmaDeliveriesFilters() {

  const pharmaDeliveriesUIContext = usePharmaDeliveriesUIContext();
  const pharmaDeliveriesUIProps = useMemo(() => {
    return {
      queryParams: pharmaDeliveriesUIContext.ordersQueryParams,
      setQueryParams: pharmaDeliveriesUIContext.setOrdersQueryParams,
      defaultView: pharmaDeliveriesUIContext.defaultView,
      setDefaultView: pharmaDeliveriesUIContext.setDefaultView,
    };
  }, [pharmaDeliveriesUIContext]);

  const { business_units } = useSelector( (state) => ({ business_units: state.helpers.BusinessUnits }), shallowEqual );
  

  const applyFilter = (values) => {
    const {searchIdText, searchOriginIdText, searchText, business_unit} = values
    let val = {
      searchIdText, 
      searchOriginIdText, 
      searchText,
      business_unit_id: business_unit.value
    }

    const newQueryParams = prepareFilter(pharmaDeliveriesUIProps.queryParams, val);

    if (!isEqual(newQueryParams, pharmaDeliveriesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      pharmaDeliveriesUIProps.setQueryParams(newQueryParams);
    }
  };


  return (
    <>
      <Formik
        initialValues={{
          business_unit: business_units?.find(bu=>bu.value==1), //shopdrofar
          searchIdText: "", 
          searchOriginIdText: "", 
          searchText: "",
        }}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-3">
                <Select 
                    options={business_units} 
                    value = {values?.business_unit || null}
                    onChange={(e) => {
                      setFieldValue("business_unit", e);
                      handleSubmit();
                    }}
                />
                <small className="form-text text-muted">
                  Filtro por <b>Unidad de Negocio</b>
                </small>
              </div> 
              <div className="col-lg-3">
                <input
                    type="text"
                    className="form-control"
                    name="searchText"
                    placeholder="Search"
                    onBlur={handleBlur}
                    value={values.searchText}
                    onChange={(e) => {
                      setFieldValue("searchText", e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className="form-text text-muted">
                    Buscar Cliente por <b>Nombre o DNI</b>
                </small>
              </div>
              
              <div className="col-lg-3">
                <input
                    type="text"
                    className="form-control"
                    name="searchIdText"
                    placeholder="Search"
                    onBlur={handleBlur}
                    value={values.searchIdText}
                    onChange={(e) => {
                      setFieldValue("searchIdText", e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className="form-text text-muted">
                    Filtro por <b>ID</b>
                </small>
              </div>
              
              <div className="col-lg-3">
              <input
                  type="text"
                  className="form-control"
                  name="searchInvoice"
                  placeholder="Search"
                  onBlur={handleBlur}
                  value={values.searchInvoice?values.searchInvoice:""}
                  onChange={(e) => {
                    setFieldValue("searchInvoice", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Filtro por <b>Nro. Factura</b>
                </small>
              </div>
              
              <div className="col-lg-3">

              </div>


            </div>


          </form>
        )}
      </Formik>
    </>
  );
}



